import { createStore, combineReducers } from 'redux';
import tokenReducer from './reducers/tokenReducer';

const rootReducer = combineReducers({
  tokenReducer,
});

const store = createStore(rootReducer);

export default store;
